/**
 * Card HTML tags
 */
export var CardTag;
(function (CardTag) {
    CardTag["article"] = "article";
    CardTag["div"] = "div";
    CardTag["section"] = "section";
})(CardTag || (CardTag = {}));
